import { DirectiveBinding } from 'vue';
import { addTask, removeTask } from './state';

interface DirectiveElement extends Element {
    componentId: number;
}

export default {
    name: 'resize',
    mounted(el: DirectiveElement, binding: DirectiveBinding) {
        el.componentId = addTask(binding.value);
    },
    beforeUnmount(el: DirectiveElement) {
        removeTask(el?.componentId?.toString());
    },
};
